import Vue from 'vue'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'
import 'normalize.css'
import App from './App.vue'
import store from './store'
import axios from 'axios'
import router from './router'
import vuetify from './plugins/vuetify'
import './plugins/prototypes'
import reactiveStorage from './plugins/reactiveStorage'
import TiptapVuetify from './plugins/TiptapVuetify'
import './plugins/leaflet'
import './plugins/dayJs'
// import vMask from './plugins/v-mask';
import VueCookies from 'vue-cookies'
import 'dhtmlx-gantt/codebase/dhtmlxgantt.css'
import VueMask from 'v-mask'

import VueLazyload from 'vue-lazyload'
import VueTelInputVuetify from 'vue-tel-input-vuetify/lib'

import AutoReload from '@/plugins/AutoReload'
import constants from './constants';

import VueRx from "vue-rx"
Vue.use(VueRx)

import VuejsClipper from "vuejs-clipper"
Vue.use(VuejsClipper)

import { DynamicReactiveRefs } from 'vue-reactive-refs'

Vue.use(DynamicReactiveRefs)
Vue.use(VueTelInputVuetify, {
  vuetify,
})

Vue.use(VueMask)

Vue.use(VueLazyload, {
  lazyComponent: true,
})
Vue.use(VueCookies)

Vue.config.productionTip = false

const token = VueCookies.get('token')
if (token) {
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
} else {
  axios.defaults.headers.common['Authorization'] = ''
}

Vue.prototype.$axios = axios

const requireComponent = require.context(
  // Относительный путь до каталога компонентов
  './components',
  // Обрабатывать или нет подкаталоги
  true,
  // Регулярное выражение для определения файлов базовых компонентов
  /(Template|Base)[A-Z]\w+\.(vue|js)$/,
)

requireComponent.keys().forEach((fileName) => {
  // Получение конфигурации компонента
  const componentConfig = requireComponent(fileName)

  // Получение имени компонента в PascalCase
  const componentName = upperFirst(
    camelCase(
      // Получаем имя файла независимо от глубины вложенности
      fileName
        .split('/')
        .pop()
        .replace(/\.\w+$/, ''),
    ),
  )
  // Глобальная регистрация компонента
  Vue.component(
    componentName,
    // Поиск опций компонента в `.default`, который будет существовать,
    // если компонент экспортирован с помощью `export default`,
    // иначе будет использован корневой уровень модуля.
    componentConfig.default || componentConfig,
  )
})

let vm = new Vue({
  router,
  axios,
  store,
  vuetify,
  // vMask,
  VueCookies,
  created() {
    Vue.use(AutoReload, {
        config: {
            // модуль включен
            Enabled: true,
            //Уведомление перез перезагрузкой
            Notification: false,
            // интервал обновления
            CheckInterval: constants.checkInterval,
        },
        router: this.$router,
        vm: this,
    });
},
  render: (h) => h(App),
}).$mount('#app')

axios.create({
  baseURL: store.state.apiDomain, //http://api.egc.fi
  headers: {
    'Content-Type': 'application/json',
    Authorization: token,
  },
})

// if (process.env.NODE_ENV === 'development') {
//   Vue.config.devtools = true
//   if (typeof window.__VUE_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined') {
//     window.__VUE_DEVTOOLS_GLOBAL_HOOK__.emit('init', Vue)
//   }
// }

export default vm
